import './bootstrap'
import { useGlobalStore } from '@stores/global'
import { useEventStore } from '@stores/event'
import { useNewsStore } from '@stores/news'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { createPinia } from 'pinia'
import router from './router'

import clickOutside from '@directives/clickOutside'

const pinia = createPinia()
const app = createApp({}).use(pinia).use(router)
const global = useGlobalStore()
const events = useEventStore()
const news = useNewsStore()

app.directive('click-outside', clickOutside)

global.setup()
events.setup()
news.setup()

/* Mount App */
app.mount('#papercrowns')
